import { useInfiniteQuery } from "@tanstack/react-query";

import { PAGE_LIMIT, apiGetPage, nextCursor, qk } from "@/shared/api";

import type { ActivityFilter } from "./types";

/**
 * Лента событий. Курсорная ручка: страница берётся по `next_cursor`, признак
 * конца — `has_more`. Пустая страница при `has_more: true` законна, поэтому
 * останов только по флагу.
 */
export function useActivityFeed(filter: ActivityFilter) {
  return useInfiniteQuery({
    queryKey: qk.activity(filter),
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam, signal }) =>
      apiGetPage("/api/v1/activity", {
        query: { filter, limit: PAGE_LIMIT, ...(pageParam ? { cursor: pageParam } : {}) },
        signal,
      }),
    getNextPageParam: (last) => nextCursor(last.meta),
  });
}
